
import Vue from 'vue';

interface Props {
  logout: () => void;
  showCustomerMenuDropdown: boolean;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  props: {
    logout: {
      type: Function,
      required: true,
    },
    showCustomerMenuDropdown: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (process.client) {
      window.document.body.addEventListener('click', (event: Record<string, any>) => {
        const loginAnchor = document.getElementById('_login');
        const loginDropdown = document.getElementsByClassName('login-dropdown')[0];
        if (loginAnchor && !loginAnchor.contains(event.target) && !loginDropdown.contains(event.target)) {
          if (loginDropdown.classList.contains('visible')) {
            this.$emit('show-customer-menu-dropdown');
          }
        }
      });
    }
  },
});
